// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3_9qq","notes":"Notes_notes__2RRRP"};